import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AIChatWidget from "./components/feature/AIChatWidget";
import FloatingEnquiryButton from "./components/feature/FloatingEnquiryButton";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import ScrollToTop from "./components/feature/ScrollToTop";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <AppRoutes />
        <AIChatWidget />
        <FloatingEnquiryButton />
        <FloatingWhatsApp />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
